import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

// export const adminMenu = [
//   {
//     menu: "Dashboard",
//     iconName: icon({ name: "house-laptop" }),
//     to: "/dashboard",
//   },
//   {
//     menu: "Doctors Calendar",
//     iconName: icon({ name: "calendar-days" }),
//     to: "/doctors-calendar",
//   },
//   {
//     menu: "Queued Patients",
//     iconName: icon({ name: "chalkboard-user" }),
//     to: "/queue",
//   },
//   {
//     menu: "Follow up Patients",
//     iconName: icon({ name: "calendar-plus" }),
//     to: "/follow-up-patients",
//   },
//   {
//     menu: "Follow up Tomorrow Patients",
//     iconName: icon({ name: "calendar-plus" }),
//     to: "/follow-up-tomorrow",
//   },
//   {
//     menu: "Patients",
//     iconName: icon({ name: "hospital-user" }),
//     to: "/patients",
//   },
//   {
//     menu: "For Evaluation",
//     iconName: icon({ name: "clipboard-list" }),
//     to: "/evaluation",
//   },
//   // {
//   //   menu: "Force Evaluation",
//   //   iconName: icon({ name: "clipboard-list" }),
//   //   to: "/force-evaluation",
//   // },
//   {
//     menu: "Prescriptions",
//     iconName: icon({ name: "pills" }),
//     to: "/prescription",
//   },
//   // {
//   //   menu: "Pharmacy",
//   //   iconName: icon({ name: "house-medical-circle-check" }),
//   //   submenu: [
//   //     // { sub: "Sales", to: "/list-of-sales" },
//   //     { sub: "Inventories", to: "/inventories" },
//   //     { sub: "Inventory Logs", to: "/inventory-logs" },
//   //     // { sub: "Summary of Patients", to: "/summary-patience" },
//   //   ],
//   // },
//   {
//     menu: "Reports",
//     iconName: icon({ name: "clipboard-list" }),
//     submenu: [
//       { sub: "Daily Logs", to: "/daily-logs" },
//       { sub: "Census of Diseases", to: "/census-of-diseases" },
//       { sub: "PCP Reports", to: "/pcp-reports" },
//       { sub: "Specialist Reports", to: "/specialist-reports" },
//       { sub: "Outpatient Visits", to: "/outpatient-visits" },
//       { sub: "Top 5 Complaints", to: "/top-5-complaints" },
//       { sub: "Doctors per day", to: "/doctors-per-day" },
//       { sub: "TAT Reports", to: "/tat-reports" },
//       { sub: "Philhealth Integrated", to: "/phil-integrated" },
//       { sub: "Konsulta Report", to: "/konsulta-reports" },
//       { sub: "Follow up Reports", to: "/followup-reports" },
//       { sub: "Philhealth Reports", to: "/philhealth-reports" },
//       { sub: "Med Affairs Reports", to: "/med-affairs-reports" },
//       { sub: "Voucher/Promo Reports", to: "/voucher-reports" },
//       { sub: "Compliance Reports", to: "/compliance-reports" },
//       { sub: "Letterhead", to: "/letterhead" },
//       // { sub: "Resident Reports", to: "/resident-reports" },
//       // { sub: "Summary of Patients", to: "/summary-patience" },
//     ],
//   },
//   // {
//   //   menu: "Users",
//   //   iconName: icon({ name: "user-doctor" }),
//   //   to: "/users",
//   // },
//   {
//     menu: "Logout",
//     iconName: icon({ name: "right-from-bracket" }),
//     to: "",
//   },
// ];

export const directorMenu = [
  {
    menu: "Dashboard",
    iconName: icon({ name: "house-laptop" }),
    to: "/dashboard",
  },
  {
    menu: "Doctors Calendar",
    iconName: icon({ name: "calendar-days" }),
    to: "/doctors-calendar",
  },
  {
    menu: "Queued Patients",
    iconName: icon({ name: "chalkboard-user" }),
    to: "/queue",
  },
  {
    menu: "Follow up Patients",
    iconName: icon({ name: "calendar-plus" }),
    to: "/follow-up-patients",
  },
  {
    menu: "Follow up Tomorrow Patients",
    iconName: icon({ name: "calendar-plus" }),
    to: "/follow-up-tomorrow",
  },
  {
    menu: "Patients",
    iconName: icon({ name: "hospital-user" }),
    to: "/patients",
  },
  {
    menu: "For Evaluation",
    iconName: icon({ name: "clipboard-list" }),
    to: "/evaluation",
  },
  // {
  //   menu: "Force Evaluation",
  //   iconName: icon({ name: "clipboard-list" }),
  //   to: "/force-evaluation",
  // },
  {
    menu: "Prescriptions",
    iconName: icon({ name: "pills" }),
    to: "/prescription",
  },
  // {
  //   menu: "Pharmacy",
  //   iconName: icon({ name: "house-medical-circle-check" }),
  //   submenu: [
  //     // { sub: "Sales", to: "/list-of-sales" },
  //     { sub: "Inventories", to: "/inventories" },
  //     { sub: "Inventory Logs", to: "/inventory-logs" },
  //     // { sub: "Summary of Patients", to: "/summary-patience" },
  //   ],
  // },
  {
    menu: "Reports",
    iconName: icon({ name: "clipboard-check" }),
    submenu: [
      { sub: "Daily Logs", to: "/daily-logs" },
      { sub: "Census of Diseases", to: "/census-of-diseases" },
      { sub: "PCP Reports", to: "/pcp-reports" },
      { sub: "Specialist Reports", to: "/specialist-reports" },
      { sub: "Outpatient Visits", to: "/outpatient-visits" },
      { sub: "Top 5 Complaints", to: "/top-5-complaints" },
      { sub: "Doctors per day", to: "/doctors-per-day" },
      { sub: "TAT Reports", to: "/tat-reports" },
      { sub: "Philhealth Integrated", to: "/phil-integrated" },
      { sub: "Konsulta Report", to: "/konsulta-reports" },
      { sub: "Follow up Reports", to: "/followup-reports" },
      { sub: "Philhealth Reports", to: "/philhealth-reports" },
      { sub: "Med Affairs Reports", to: "/med-affairs-reports" },
      { sub: "Voucher/Promo Reports", to: "/voucher-reports" },
      { sub: "Compliance Reports", to: "/compliance-reports" },
      { sub: "Letterhead", to: "/letterhead" },
      // { sub: "Resident Reports", to: "/resident-reports" },
      // { sub: "Summary of Patients", to: "/summary-patience" },
    ],
  },
  // {
  //   menu: "Users",
  //   iconName: icon({ name: "user-doctor" }),
  //   to: "/users",
  // },
  {
    menu: "Logout",
    iconName: icon({ name: "right-from-bracket" }),
    to: "",
  },
];

export const specialistMenu = [
  {
    menu: "Dashboard",
    iconName: icon({ name: "house-laptop" }),
    to: "/dashboard",
  },
  {
    menu: "Doctors Calendar",
    iconName: icon({ name: "calendar-days" }),
    to: "/doctors-calendar",
  },
  {
    menu: "Queued Patients",
    iconName: icon({ name: "chalkboard-user" }),
    to: "/queue",
  },
  {
    menu: "Follow up Patients",
    iconName: icon({ name: "calendar-plus" }),
    to: "/follow-up-patients",
  },
  {
    menu: "Follow up Tomorrow Patients",
    iconName: icon({ name: "calendar-plus" }),
    to: "/follow-up-tomorrow",
  },
  {
    menu: "Patients",
    iconName: icon({ name: "hospital-user" }),
    to: "/patients",
  },
  // {
  //   menu: "For Evaluation",
  //   iconName: icon({ name: "clipboard-list" }),
  //   to: "/evaluation",
  // },
  // {
  //   menu: "Force Evaluation",
  //   iconName: icon({ name: "clipboard-list" }),
  //   to: "/force-evaluation",
  // },
  // {
  //   menu: "Prescriptions",
  //   iconName: icon({ name: "pills" }),
  //   to: "/prescription",
  // },
  // {
  //   menu: "Pharmacy",
  //   iconName: icon({ name: "house-medical-circle-check" }),
  //   submenu: [
  //     // { sub: "Sales", to: "/list-of-sales" },
  //     { sub: "Inventories", to: "/inventories" },
  //     { sub: "Inventory Logs", to: "/inventory-logs" },
  //     // { sub: "Summary of Patients", to: "/summary-patience" },
  //   ],
  // },
  // {
  //   menu: "Reports",
  //   iconName: icon({ name: "clipboard-list" }),
  //   submenu: [
  //     { sub: "Daily Logs", to: "/daily-logs" },
  //     { sub: "Census of Diseases", to: "/census-of-diseases" },
  //     { sub: "PCP Reports", to: "/pcp-reports" },
  //     { sub: "Specialist Reports", to: "/specialist-reports" },
  //     { sub: "Outpatient Visits", to: "/outpatient-visits" },
  //     { sub: "Top 5 Complaints", to: "/top-5-complaints" },
  //     { sub: "Doctors per day", to: "/doctors-per-day" },
  //     { sub: "TAT Reports", to: "/tat-reports" },
  //     { sub: "Philhealth Integrated", to: "/phil-integrated" },
  //     { sub: "Konsulta Report", to: "/konsulta-reports" },
  //     { sub: "Follow up Reports", to: "/followup-reports" },
  //     { sub: "Philhealth Reports", to: "/philhealth-reports" },
  //     { sub: "Med Affairs Reports", to: "/med-affairs-reports" },
  //     { sub: "Voucher/Promo Reports", to: "/voucher-reports" },
  //     { sub: "Compliance Reports", to: "/compliance-reports" },
  //     { sub: "Letterhead", to: "/letterhead" },
  //     // { sub: "Resident Reports", to: "/resident-reports" },
  //     // { sub: "Summary of Patients", to: "/summary-patience" },
  //   ],
  // },
  // {
  //   menu: "Users",
  //   iconName: icon({ name: "user-doctor" }),
  //   to: "/users",
  // },
  {
    menu: "Logout",
    iconName: icon({ name: "right-from-bracket" }),
    to: "",
  },
];

export const PCPMenu = [
  {
    menu: "Dashboard",
    iconName: icon({ name: "house-laptop" }),
    to: "/dashboard",
  },
  {
    menu: "Doctors Calendar",
    iconName: icon({ name: "calendar-days" }),
    to: "/doctors-calendar",
  },
  {
    menu: "Queued Patients",
    iconName: icon({ name: "chalkboard-user" }),
    to: "/queue",
  },
  {
    menu: "Follow up Patients",
    iconName: icon({ name: "calendar-plus" }),
    to: "/follow-up-patients",
  },
  {
    menu: "Follow up Tomorrow Patients",
    iconName: icon({ name: "calendar-plus" }),
    to: "/follow-up-tomorrow",
  },
  {
    menu: "Patients",
    iconName: icon({ name: "hospital-user" }),
    to: "/patients",
  },
  {
    menu: "For Evaluation",
    iconName: icon({ name: "clipboard-list" }),
    to: "/evaluation",
  },
  // {
  //   menu: "Force Evaluation",
  //   iconName: icon({ name: "clipboard-list" }),
  //   to: "/force-evaluation",
  // },
  // {
  //   menu: "Prescriptions",
  //   iconName: icon({ name: "pills" }),
  //   to: "/prescription",
  // },
  // {
  //   menu: "Pharmacy",
  //   iconName: icon({ name: "house-medical-circle-check" }),
  //   submenu: [
  //     // { sub: "Sales", to: "/list-of-sales" },
  //     { sub: "Inventories", to: "/inventories" },
  //     { sub: "Inventory Logs", to: "/inventory-logs" },
  //     // { sub: "Summary of Patients", to: "/summary-patience" },
  //   ],
  // },
  // {
  //   menu: "Reports",
  //   iconName: icon({ name: "clipboard-list" }),
  //   submenu: [
  //     { sub: "Daily Logs", to: "/daily-logs" },
  //     { sub: "Census of Diseases", to: "/census-of-diseases" },
  //     { sub: "PCP Reports", to: "/pcp-reports" },
  //     { sub: "Specialist Reports", to: "/specialist-reports" },
  //     { sub: "Outpatient Visits", to: "/outpatient-visits" },
  //     { sub: "Top 5 Complaints", to: "/top-5-complaints" },
  //     { sub: "Doctors per day", to: "/doctors-per-day" },
  //     { sub: "TAT Reports", to: "/tat-reports" },
  //     { sub: "Philhealth Integrated", to: "/phil-integrated" },
  //     { sub: "Konsulta Report", to: "/konsulta-reports" },
  //     { sub: "Follow up Reports", to: "/followup-reports" },
  //     { sub: "Philhealth Reports", to: "/philhealth-reports" },
  //     { sub: "Med Affairs Reports", to: "/med-affairs-reports" },
  //     { sub: "Voucher/Promo Reports", to: "/voucher-reports" },
  //     { sub: "Compliance Reports", to: "/compliance-reports" },
  //     { sub: "Letterhead", to: "/letterhead" },
  //     // { sub: "Resident Reports", to: "/resident-reports" },
  //     // { sub: "Summary of Patients", to: "/summary-patience" },
  //   ],
  // },
  // {
  //   menu: "Users",
  //   iconName: icon({ name: "user-doctor" }),
  //   to: "/users",
  // },
  {
    menu: "Logout",
    iconName: icon({ name: "right-from-bracket" }),
    to: "",
  },
];

export const residentMenu = [
  {
    menu: "Dashboard",
    iconName: icon({ name: "house-laptop" }),
    to: "/dashboard",
  },
  {
    menu: "Doctors Calendar",
    iconName: icon({ name: "calendar-days" }),
    to: "/doctors-calendar",
  },
  {
    menu: "Queued Patients",
    iconName: icon({ name: "chalkboard-user" }),
    to: "/queue",
  },
  {
    menu: "Follow up Patients",
    iconName: icon({ name: "calendar-plus" }),
    to: "/follow-up-patients",
  },
  {
    menu: "Follow up Tomorrow Patients",
    iconName: icon({ name: "calendar-plus" }),
    to: "/follow-up-tomorrow",
  },
  {
    menu: "Patients",
    iconName: icon({ name: "hospital-user" }),
    to: "/patients",
  },
  {
    menu: "Prescriptions",
    iconName: icon({ name: "pills" }),
    to: "/prescription",
  },
  // {
  //   menu: "Pharmacy",
  //   iconName: icon({ name: "house-medical-circle-check" }),
  //   submenu: [
  //     // { sub: "Sales", to: "/list-of-sales" },
  //     { sub: "Inventories", to: "/inventories" },
  //     { sub: "Inventory Logs", to: "/inventory-logs" },
  //     // { sub: "Summary of Patients", to: "/summary-patience" },
  //   ],
  // },
  {
    menu: "Reports",
    iconName: icon({ name: "clipboard-list" }),
    submenu: [
      { sub: "Daily Logs", to: "/daily-logs" },
      { sub: "Census of Diseases", to: "/census-of-diseases" },
      // { sub: "PCP Reports", to: "/pcp-reports" },
      { sub: "Outpatient Visits", to: "/outpatient-visits" },
      { sub: "Follow up Reports", to: "/followup-reports" },
      { sub: "Philhealth Reports", to: "/philhealth-reports" },
      { sub: "Voucher/Promo Reports", to: "/voucher-reports" },
      { sub: "Compliance Reports", to: "/compliance-reports" },
      { sub: "Letterhead", to: "/letterhead" },
      // { sub: "Summary of Patients", to: "/summary-patience" },
    ],
  },
  {
    menu: "Users",
    iconName: icon({ name: "user-doctor" }),
    to: "/users",
  },
  {
    menu: "Logout",
    iconName: icon({ name: "right-from-bracket" }),
    to: "",
  },
];

export const nurseMenu = [
  {
    menu: "Dashboard",
    iconName: icon({ name: "house-laptop" }),
    to: "/dashboard",
  },
  // {
  //   menu: "Doctors Calendar",
  //   iconName: icon({ name: "calendar-days" }),
  //   to: "/doctors-calendar",
  // },
  // {
  //   menu: "Queued Patients",
  //   iconName: icon({ name: "chalkboard-user" }),
  //   to: "/queue",
  // },
  // {
  //   menu: "Follow up Patients",
  //   iconName: icon({ name: "calendar-plus" }),
  //   to: "/follow-up-patients",
  // },
  // {
  //   menu: "Follow up Tomorrow Patients",
  //   iconName: icon({ name: "calendar-plus" }),
  //   to: "/follow-up-tomorrow",
  // },
  {
    menu: "Patients",
    iconName: icon({ name: "hospital-user" }),
    to: "/patients",
  },
  // {
  //   menu: "Prescriptions",
  //   iconName: icon({ name: "pills" }),
  //   to: "/prescription",
  // },
  // {
  //   menu: "Pharmacy",
  //   iconName: icon({ name: "house-medical-circle-check" }),
  //   submenu: [
  //     // { sub: "Sales", to: "/list-of-sales" },
  //     { sub: "Inventories", to: "/inventories" },
  //     { sub: "Inventory Logs", to: "/inventory-logs" },
  //   ],
  // },
//  {
//     menu: "Reports",
//     iconName: icon({ name: "clipboard-list" }),
//     submenu: [
//       { sub: "Daily Logs", to: "/daily-logs" },
//       { sub: "Census of Diseases", to: "/census-of-diseases" },
//       { sub: "PCP Reports", to: "/pcp-reports" },
//       { sub: "Specialist Reports", to: "/specialist-reports" },
//       { sub: "Outpatient Visits", to: "/outpatient-visits" },
//       { sub: "Top 5 Complaints", to: "/top-5-complaints" },
//       { sub: "Doctors per day", to: "/doctors-per-day" },
//       { sub: "TAT Reports", to: "/tat-reports" },
//       { sub: "Philhealth Integrated", to: "/phil-integrated" },
//       { sub: "Konsulta Report", to: "/konsulta-reports" },
//       { sub: "Follow up Reports", to: "/followup-reports" },
//       { sub: "Philhealth Reports", to: "/philhealth-reports" },
//       { sub: "Med Affairs Reports", to: "/med-affairs-reports" },
//       { sub: "Voucher/Promo Reports", to: "/voucher-reports" },
//       { sub: "Compliance Reports", to: "/compliance-reports" },
//       { sub: "Letterhead", to: "/letterhead" },
//       // { sub: "Resident Reports", to: "/resident-reports" },
//       // { sub: "Summary of Patients", to: "/summary-patience" },
//     ],
//   },
  {
    menu: "Logout",
    iconName: icon({ name: "right-from-bracket" }),
    to: "",
  },
];

export const laboratoryMenu = [
  {
    menu: "Patients",
    iconName: icon({ name: "hospital-user" }),
    to: "/patients",
  },
  {
    menu: "Logout",
    iconName: icon({ name: "right-from-bracket" }),
    to: "",
  },
];

export const supervisorMenu = [
  {
    menu: "Doctors Calendar",
    iconName: icon({ name: "calendar-days" }),
    to: "/doctors-calendar",
  },
 {
    menu: "Reports",
    iconName: icon({ name: "clipboard-list" }),
    submenu: [
      { sub: "Daily Logs", to: "/daily-logs" },
      { sub: "Census of Diseases", to: "/census-of-diseases" },
      { sub: "PCP Reports", to: "/pcp-reports" },
      { sub: "Specialist Reports", to: "/specialist-reports" },
      { sub: "Outpatient Visits", to: "/outpatient-visits" },
      { sub: "Top 5 Complaints", to: "/top-5-complaints" },
      { sub: "Doctors per day", to: "/doctors-per-day" },
      { sub: "TAT Reports", to: "/tat-reports" },
      { sub: "Philhealth Integrated", to: "/phil-integrated" },
      { sub: "Konsulta Report", to: "/konsulta-reports" },
      { sub: "Follow up Reports", to: "/followup-reports" },
      { sub: "Philhealth Reports", to: "/philhealth-reports" },
      { sub: "Med Affairs Reports", to: "/med-affairs-reports" },
      { sub: "Voucher/Promo Reports", to: "/voucher-reports" },
      { sub: "Compliance Reports", to: "/compliance-reports" },
      { sub: "Letterhead", to: "/letterhead" },
      // { sub: "Resident Reports", to: "/resident-reports" },
      // { sub: "Summary of Patients", to: "/summary-patience" },
    ],
  },
  {
    menu: "Logout",
    iconName: icon({ name: "right-from-bracket" }),
    to: "",
  },
];
